import { HttpClientModule } from '@angular/common/http';
import { APP_INITIALIZER, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { FaIconLibrary } from '@fortawesome/angular-fontawesome';
import { faCamera, faEdit, faMinus, faPlus, faTrash, faWindowClose } from '@fortawesome/free-solid-svg-icons';
import { TranslationsService } from 'pages/general/services';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

@NgModule({
    declarations: [AppComponent],
    imports: [BrowserModule, AppRoutingModule, HttpClientModule, BrowserAnimationsModule],
    providers: [
        {
            provide: APP_INITIALIZER,
            useFactory: (translationService: TranslationsService) => () => translationService.changeLanguage(localStorage.getItem("locale") || 'en'), // Idioma padrão
            deps: [TranslationsService],
            multi: true
        }
    ],
    bootstrap: [AppComponent],
})
export class AppModule {
    constructor(library: FaIconLibrary) {
        library.addIcons(faPlus, faMinus, faTrash, faEdit, faCamera, faWindowClose);
    }
}
